import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon";

const Chat: React.FC<IconPresentationProps> = props => {
    return (
        <svg
            fill="#ffffff"
            height="64px"
            width="64px"
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
        >
            {props.title && <title>{props.title}</title>}
            <g strokeWidth="0"></g>
            <g strokeLinecap="round" strokeLinejoin="round"></g>
            <g>
                <g>
                    <g>
                        <g>
                            <path
                                d="M442.213,0H176.464c-32.597,0-59.136,26.517-59.136,59.115V64h218.219c56.128,0,101.781,45.675,101.781,101.781v132.885 h4.885c32.597,0,59.115-26.517,59.115-59.115V59.115C501.328,26.517,474.811,0,442.213,0z"
                            ></path>
                            <path
                                d="M335.557,106.667H69.787c-32.597,0-59.115,26.517-59.115,59.115v180.437c0,32.597,26.517,59.115,59.115,59.115h4.885 v85.333c0,8.619,5.184,16.405,13.163,19.712c2.645,1.088,5.419,1.621,8.171,1.621c5.547,0,11.008-2.176,15.083-6.251 l100.416-100.416h124.053c32.597,0,59.115-26.517,59.115-59.115V165.781C394.672,133.184,368.155,106.667,335.557,106.667z M117.339,277.333c-11.776,0-21.333-9.557-21.333-21.333s9.557-21.333,21.333-21.333s21.333,9.557,21.333,21.333 S129.115,277.333,117.339,277.333z M202.672,277.333c-11.776,0-21.333-9.557-21.333-21.333s9.557-21.333,21.333-21.333 s21.333,9.557,21.333,21.333S214.448,277.333,202.672,277.333z M288.005,277.333c-11.776,0-21.333-9.557-21.333-21.333 s9.557-21.333,21.333-21.333s21.333,9.557,21.333,21.333S299.781,277.333,288.005,277.333z"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(Chat);
